/* eslint-disable consistent-return */
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Button, FormLabel, Grid, MenuItem, Checkbox } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  createFormation,
  getAddress,
  getCertificationAuthority,
  getDegreeLevel,
  getDegreeRequirements,
  getLangFormation,
  getCFAsBySchool,
  getStudyPlan,
  getTrainingDomains,
  getTrainingType,
} from '@webapps/business';
import {
  FormikAutocomplete,
  FormikAutocompletePx,
  FormikDatePicker,
  FormikTextField,
  TextField,
  TextFieldPx,
  useAuth,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { format } from 'date-fns';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { LAST_DISPLOMA } from 'config/constants';

const CreateFormation = ({ onChangeStepModal, onClose, refetchFormation }) => {
  const { idUser } = useAuth();

  // const date = new Date();

  useEffect(() => {
    onChangeStepModal(1);
  }, []);

  const [data, setData] = useState({
    school: {
      id: idUser,
    },
    label: '',
    description: '',
    workedLangage: [],
    cfa: {
      id: '',
    },
    cfaLocation: false,
    domain: {
      id: '',
    },
    degree: {
      id: '',
    },
    entryRequierement: {
      id: '',
    },
    address: {
      label: '',
      cityCode: '',
      city: '',
    },
    studyPlan: {
      id: '',
    },
    trainingType: {
      id: '',
      label: '',
    },
    certifyingAuthority: {
      id: '',
    },
    duration: '',
    onlyVerfiedProfile: false,
    registrationFees: '',
    programCost: '',
    openingDate: '',
    closingDate: '',
    applicationStartDate: '',
    applicationClosingDate: '',
    rythmAlternance: {
      nbSchool: '',
      dayOrWeekSchool: '',
      nbBusiness: '',
      dayOrWeekBusiness: '',
    },
    rncp: '',
    diplomaType: '',
    diplomaCode: '',
    diplomaLabel: '',
    trainingLabel: '',
    trainingDuration: '',
    trainingRemoteDuration: '',
    trainingTotalCost: '',
  });
  const [currentStep, setCurrentStep] = useState(0);

  const {
    error,
    isLoading: isLoadingCreateFormation,
    isSuccess,
    mutateAsync: mutateCreateFormation,
  } = useMutation(createFormation);

  const { addToast } = useToast();

  useEffect(() => {
    if (error) {
      addToast({
        status: 'error',
        message: 'Erreur pour publier une formation',
      });
    }
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Formation publiée avec succès',
      });
      onClose();
      refetchFormation();
    }
  }, [error, isSuccess]);

  const makeRequest = async ({
    applicationClosingDate,
    applicationStartDate,
    openingDate,
    closingDate,
    rythmAlternance,
    cfa,
    ...values
  }) => {
    const formattedRythmAlternance = rythmAlternance
    ? `${rythmAlternance.nbSchool} ${rythmAlternance.dayOrWeekSchool} / ${rythmAlternance.nbBusiness} ${rythmAlternance.dayOrWeekBusiness}`
    : null;
    await mutateCreateFormation({
      data: {
        openingDate: format(new Date(openingDate), "yyyy-MM-dd'T'HH:mm:ss"),
        closingDate: format(new Date(closingDate), "yyyy-MM-dd'T'HH:mm:ss"),
        applicationStartDate: format(
          new Date(applicationStartDate),
          "yyyy-MM-dd'T'HH:mm:ss"
        ),
        applicationClosingDate: format(
          new Date(applicationClosingDate),
          "yyyy-MM-dd'T'HH:mm:ss"
        ),
        rythmAlternance: formattedRythmAlternance,
        cfa: cfa?.id ? { id: cfa.id } : null,
        ...values,
      },
    });
  };

  const handleNextStep = (newData, final = false) => {
    setData((prev) => ({ ...prev, ...newData }));

    if (final) {
      makeRequest(newData);
      return;
    }

    setCurrentStep((prev) => prev + 1);
    onChangeStepModal((prev) => prev + 1);
  };

  const handlePrevStep = (newData) => {
    setData((prev) => ({ ...prev, ...newData }));
    setCurrentStep((prev) => prev - 1);
    onChangeStepModal((prev) => prev - 1);
  };

  const steps = [
    <StepOne key={1} data={data} next={handleNextStep} />,
    <StepTwo key={2} data={data} next={handleNextStep} prev={handlePrevStep} />,
    <StepThree
      key={3}
      data={data}
      next={handleNextStep}
      prev={handlePrevStep}
    />,
    <StepFour
      key={4}
      data={data}
      next={handleNextStep}
      prev={handlePrevStep}
    />,
    <StepFive
      key={5}
      data={data}
      isLoading={isLoadingCreateFormation}
      next={handleNextStep}
      prev={handlePrevStep}
    />,
  ];

  return steps[currentStep];
};

CreateFormation.propTypes = {
  onClose: PropTypes.func,
  refetchFormation: PropTypes.func,
  onChangeStepModal: PropTypes.func,
};

const stepOneValidationSchema = Yup.object({
  degree: Yup.object().shape({
    id: Yup.string().required('Requis'),
  }),
  label: Yup.string().required('Requis'),
  address: Yup.object()
    .shape({
      label: Yup.string().required('Requis'),
      city: Yup.string().required('Requis'),
      cityCode: Yup.string().required('Requis'),
    })
    .required('Requis'),
  trainingType: Yup.object()
    .shape({
      id: Yup.string().required('Requis'),
    })
    .required('Requis'),
  domain: Yup.object()
    .shape({
      id: Yup.string().required('Requis'),
    })
    .required('Requis'),
});

const PROFIL_STATUS = [
  {
    label: 'Oui',
    value: true,
  },
  {
    label: 'Non',
    value: false,
  },
];

const StepOne = ({ data, next }) => {
  const {
    css,
    theme: { spacing },
  } = useStyles();

  const { idUser } = useAuth();

  const { data: degreeLevels = [] } = useQuery(getDegreeLevel, {
    key: 'degreeLevels',
  });

  const { data: trainingTypes = [] } = useQuery(getTrainingType, {
    key: 'trainingTypes',
  });

  const { data: { content: trainingDomains = [] } = {} } = useQuery(
    getTrainingDomains,
    {
      key: 'trainingDomains',
    }
  );
  const { data: cfas = {} } = useQuery(getCFAsBySchool, {
    key: 'cfas',
    variables: { id: idUser },
  });

  const [addresses, setAddresses] = useState([]);

  const getAdresses = useMutation(getAddress, {
    onSuccess: (result) => {
      setAddresses(result?.data?.features);
    },
  });

  const formik = useFormik({
    initialValues: data,
    enableReinitialize: true,
    validationSchema: stepOneValidationSchema,
    onSubmit: (values) => {
      next(values);
    },
  });

  const getAllInfoAdresses = useMutation(getAddress, {
    onSuccess: (result) => {
      formik.setFieldValue(
        'address.label',
        result?.data?.features[0]?.properties?.label
      );
      formik.setFieldValue(
        'address.city',
        result?.data?.features[0]?.properties?.city
      );
      formik.setFieldValue(
        'address.cityCode',
        result?.data?.features[0]?.properties?.postcode
      );
    },
  });

  const changeAddress = async (value) => {
    getAllInfoAdresses.mutateAsync({ name: value || 'test' });
  };

  const handleChangeAddress = async (searchValue) => {
    if (!searchValue.target.value) {
      return null;
    }
    await getAdresses.mutateAsync({ name: searchValue.target.value });
  };


  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: spacing(3),
        '@media (max-width:768px)': { margin: spacing(0) }
      })}
    >
      <Grid container >
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikAutocompletePx
              defaultValue=""
              formik={formik}
              borderRadius={6}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              getOptionSelected={(option, value) => value.id === option.id}
              label="Niveau de diplome"
              name="degree.id"
              options={degreeLevels}
              pathValue="id"
              value={
                degreeLevels.find(({ id }) => id === formik.values.degree.id) ||
                null
              }
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              borderRadius={6}
              fullWidth
              label="Nom de la formation"
              name="label"
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikAutocompletePx
              defaultValue=""
              borderRadius={6}
              formik={formik}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              getOptionSelected={(option, value) => value.id === option.id}
              label="Type de formation"
              name="trainingType"
              options={trainingTypes}
              value={
                trainingTypes.find(
                  (trainingType) => trainingType?.id === formik.values.trainingType?.id
                ) || null
              }
            />
          </Grid>
        </Grid>
        {formik.values.trainingType?.label === "Alternance" && cfas.length > 0 && (
          <Grid className={css({ marginTop: spacing(3) })} container>
            <FormikAutocompletePx
              defaultValue=""
              borderRadius={6}
              formik={formik}
              fullWidth
              getOptionLabel={(option) => option.name || ''}
              getOptionSelected={(option, value) => value.id === option.id}
              label="Ajouter un CFA (Optionnel)"
              name="cfa.id"
              options={cfas}
              pathValue="id"
              value={
                cfas.find(
                  ({ id }) => id === formik.values.cfa.id
                ) || null
              }
            />
          </Grid>
        )}
        {formik.values.cfa?.id && (
          <Grid className={css({ marginTop: spacing(3) })} container>
            <FormLabel>Le CFA est situé dans l'établissement</FormLabel>
              <Checkbox
                checked={formik.values.cfaLocation}
                name="cfaLocation"
                size="small"
                onChange={() => formik.setFieldValue('cfaLocation', !formik.values.cfaLocation)}
              />
          </Grid>
        )}
        {formik.values.trainingType?.label === 'Alternance' && (
          <Grid justifyContent='center' container>
            <Grid item xs={12}>
              <p className={css({
                fontSize: '1rem',
                paddingLeft: spacing(1),
                borderLeft: '3px solid #0060F9',
                fontWeight: '400',
                color: '#5D75A8',
              })}>Cycle d'alternance</p>
            </Grid>
          </Grid>
        )}
        {formik.values.trainingType?.label === 'Alternance' && (
          <>
            <p className={css({
              fontSize: '0.9rem',
              marginLeft: spacing(2),
              fontWeight: '400',
              color: '#5D75A8',
            })}>À l'école</p>
            <Grid className={css({ gap: spacing(1) })} justifyContent='center' container>
              <Grid item xs={5}>
                <FormikAutocompletePx
                  defaultValue=""
                  formik={formik}
                  borderRadius={6}
                  fullWidth
                  getOptionLabel={(option) => option.label || ''}
                  getOptionSelected={(option, value) => value.id === option.id}
                  label="Nombre"
                  name="rythmAlternance.nbSchool"
                  options={[
                    // 1 to 10
                    { label: '1', id: '1' },
                    { label: '2', id: '2' },
                    { label: '3', id: '3' },
                    { label: '4', id: '4' },
                    { label: '5', id: '5' },
                    { label: '6', id: '6' },
                    { label: '7', id: '7' },
                    { label: '8', id: '8' },
                    { label: '9', id: '9' },
                    { label: '10', id: '10' },
                  ]}
                  pathValue="id"
                  value={
                    formik.values.rythmAlternance
                      ? { label: formik.values.rythmAlternance.nbSchool, id: formik.values.rythmAlternance.nbSchool }
                      : null
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <FormikAutocompletePx
                  defaultValue=""
                  formik={formik}
                  borderRadius={6}
                  fullWidth
                  getOptionLabel={(option) => option.label || ''}
                  getOptionSelected={(option, value) => value.id === option.id}
                  label="Type de rythme"
                  name="rythmAlternance.dayOrWeekSchool"
                  options={[
                    // jour ou semaine
                    { label: 'jour(s)', id: 'jour(s)' },
                    { label: 'semaine(s)', id: 'semaine(s)' },
                  ]}
                  pathValue="id"
                  value={
                    formik.values.rythmAlternance
                      ? { label: formik.values.rythmAlternance.dayOrWeekSchool, id: formik.values.rythmAlternance.dayOrWeekSchool }
                      : null
                  }
                />
              </Grid>
            </Grid>
          </>
        )}
        {formik.values.trainingType?.label === 'Alternance' && (
          <>
            <p className={css({
              fontSize: '0.9rem',
              marginLeft: spacing(2),
              fontWeight: '400',
              color: '#5D75A8',
            })}>En entreprise</p>
            <Grid className={css({ gap: spacing(1) })} justifyContent='center' container>
              <Grid item xs={5}>
                <FormikAutocompletePx
                  defaultValue=""
                  formik={formik}
                  borderRadius={6}
                  fullWidth
                  getOptionLabel={(option) => option.label || ''}
                  getOptionSelected={(option, value) => value.id === option.id}
                  label="Nombre"
                  name="rythmAlternance.nbBusiness"
                  options={[
                    // 1 to 10
                    { label: '1', id: '1' },
                    { label: '2', id: '2' },
                    { label: '3', id: '3' },
                    { label: '4', id: '4' },
                    { label: '5', id: '5' },
                    { label: '6', id: '6' },
                    { label: '7', id: '7' },
                    { label: '8', id: '8' },
                    { label: '9', id: '9' },
                    { label: '10', id: '10' },
                  ]}
                  pathValue="id"
                  value={
                    formik.values.rythmAlternance
                      ? { label: formik.values.rythmAlternance.nbBusiness, id: formik.values.rythmAlternance.nbBusiness }
                      : null
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <FormikAutocompletePx
                  defaultValue=""
                  borderRadius={6}
                  formik={formik}
                  fullWidth
                  getOptionLabel={(option) => option.label || ''}
                  getOptionSelected={(option, value) => value.id === option.id}
                  label="Type de rythme"
                  name="rythmAlternance.dayOrWeekBusiness"
                  options={[
                    // jour ou semaine
                    { label: 'jour(s)', id: 'jour(s)' },
                    { label: 'semaine(s)', id: 'semaine(s)' },
                  ]}
                  pathValue="id"
                  value={
                    formik.values.rythmAlternance
                      ? { label: formik.values.rythmAlternance.dayOrWeekBusiness, id: formik.values.rythmAlternance.dayOrWeekBusiness }
                      : null
                  }
                />
              </Grid>
            </Grid>
          </>
        )}
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikAutocompletePx
              defaultValue=""
              formik={formik}
              borderRadius={6}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              getOptionSelected={(option, value) => value.id === option.id}
              label="Domaine d'étude"
              name="domain.id"
              options={trainingDomains}
              pathValue="id"
              value={
                trainingDomains.find(
                  ({ id }) => id === formik.values.domain.id
                ) || null
              }
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(2) })} container>
          <Grid item xs={12}>
            <Autocomplete
              autoComplete={false}
              borderRadius={6}
              defaultValue={formik?.values.address.label || ''}
              getOptionLabel={(option) => option || ''}
              onInputChange={(event, value) => {
                changeAddress(value);
              }}
              options={addresses?.map((option) => option?.properties?.label)}
              renderInput={(params) => (
                <TextFieldPx
                  borderRadius={6}
                  {...params}
                  defaultValue=""
                  error={
                    !!formik.errors.address?.label &&
                    !!formik.errors.address?.label
                  }
                  helperText={
                    formik.errors.address?.label && formik.errors.address?.label
                  }
                  label="Adresse"
                  name="address.label"
                  onChange={(value) => {
                    handleChangeAddress(value);
                  }}
                  placeholder="N°rue code postal"
                  value={formik.values.address.label}
                  variant="outlined"
                />
              )}
              size="small"
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid
          className={css({ textAlign: 'center', marginTop: spacing(4) })}
          item
          xs
        >
          <Button
            className={css({ borderRadius: 20 })}
            color="primary"
            fullWidth
            onClick={formik.handleSubmit}
            type="submit"
            variant="contained"
          >
            Suivant
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

StepOne.propTypes = {
  data: PropTypes.object,
  next: PropTypes.func,
};

const stepTwoValidationSchema = Yup.object({
  entryRequierement: Yup.object()
    .shape({
      id: Yup.string().required('Requis'),
    })
    .required('Requis'),
  certifyingAuthority: Yup.object()
    .shape({
      id: Yup.string().required('Requis'),
    })
    .required('Requis'),
  duration: Yup.number()
    .positive('Le nombre doit être positif')
    .required('Requis'),
  studyPlan: Yup.object()
    .shape({
      id: Yup.string().required('Requis'),
    })
    .required('Requis'),
  onlyVerfiedProfile: Yup.bool().required('Requis'),
});

const StepTwo = ({ data, next, prev }) => {
  const {
    css,
    theme: { spacing },
  } = useStyles();

  const { data: requirements = [] } = useQuery(getDegreeRequirements, {
    key: 'requirements',
  });

  const { data: certifs = [] } = useQuery(getCertificationAuthority, {
    key: 'certifs',
  });

  const { data: studyPlans = [] } = useQuery(getStudyPlan, {
    key: 'studyPlans',
  });

  const formik = useFormik({
    initialValues: data,
    validationSchema: stepTwoValidationSchema,
    onSubmit: (values) => next(values),
  });

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: spacing(3),
        '@media (max-width:768px)': { margin: spacing(1) }
      })}
    >
      <Grid container  >
        <Grid container>
          <Grid item xs={12}>
            <FormikAutocompletePx
              defaultValue=""
              formik={formik}
              borderRadius={6}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              getOptionSelected={(option, value) => value.id === option.id}
              label="Condition d'admission"
              name="entryRequierement.id"
              options={requirements}
              pathValue="id"
              value={
                requirements.find(
                  ({ id }) => id === formik.values.entryRequierement.id
                ) || null
              }
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikAutocompletePx
              defaultValue=""
              formik={formik}
              borderRadius={6}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              getOptionSelected={(option, value) => value.id === option.id}
              label="Reconnaissance du diplôme"
              name="certifyingAuthority.id"
              options={certifs}
              pathValue="id"
              value={
                certifs.find(
                  ({ id }) => id === formik.values.certifyingAuthority.id
                ) || null
              }
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              borderRadius={6}
              fullWidth
              InputProps={{ inputProps: { min: 0 } }}
              label="Durée de la formation (en mois)"
              name="duration"
              type="number"
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              borderRadius={6}
              fullWidth
              label="Durée de la formation (en heures)"
              name="trainingDuration"
              type="number"
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              borderRadius={6}
              fullWidth
              label="Durée de la formation en distancielle (en heures)"
              name="trainingRemoteDuration"
              type="number"
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikAutocompletePx
              defaultValue=""
              formik={formik}
              borderRadius={6}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              getOptionSelected={(option, value) => value.id === option.id}
              label="Présence"
              name="studyPlan.id"
              options={studyPlans}
              pathValue="id"
              value={
                studyPlans.find(
                  ({ id }) => id === formik.values.studyPlan.id
                ) || null
              }
            />
          </Grid>
        </Grid>
        {/* <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              borderRadius={6}
              fullWidth
              label="Profils vérifiés uniquement (par Linkpick)"
              name="onlyVerfiedProfile"
              select
            >
              {PROFIL_STATUS.map(({ label, value }, index) => (
                <MenuItem key={index} value={value}>
                  {label}
                </MenuItem>
              ))}
            </FormikTextField>
          </Grid>
        </Grid> */}
      </Grid>
      <Grid container spacing={2}>
        <Grid
          className={css({
            textAlign: 'center',
            marginTop: spacing(4),
          })}
          item
          xs
        >
          <Button
            className={css({ borderRadius: 20 })}
            color="primary"
            fullWidth
            onClick={() => prev(formik.values)}
            variant="outlined"
          >
            Retour
          </Button>
        </Grid>
        <Grid
          className={css({
            textAlign: 'center',
            marginTop: spacing(4),
          })}
          item
          xs
        >
          <Button
            className={css({ borderRadius: 20 })}
            color="primary"
            fullWidth
            onClick={formik.handleSubmit}
            type="submit"
            variant="contained"
          >
            Suivant
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

StepTwo.propTypes = {
  data: PropTypes.object,
  next: PropTypes.func,
  prev: PropTypes.func,
};

const stepThreeValidationSchema = Yup.object({
  rncp: Yup.string().required('Requis'),
  diplomaCode: Yup.string().required('Requis'),
  diplomaLabel: Yup.string().required('Requis'),
  trainingLabel: Yup.string().required('Requis'),
});

const StepThree = ({ data, next, prev }) => {
  const {
    css,
    theme: { spacing },
  } = useStyles();

  const { idUser } = useAuth();

  const formik = useFormik({
    initialValues: data,
    validationSchema: stepThreeValidationSchema,
    onSubmit: (values) => next(values),
  });

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: spacing(3),
        '@media (max-width:768px)': { margin: spacing(1) }
      })}
    >
      <Grid container xs={12}>
        <Grid container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              borderRadius={6}
              fullWidth
              label="Code RNCP"
              name="rncp"
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikAutocompletePx
              defaultValue=""
              formik={formik}
              borderRadius={6}
              fullWidth
              getOptionLabel={(option) => option.label || ''}
              getOptionSelected={(option, value) => value.value === option.value}
              label="Type de diplôme"
              name="diplomaType"
              options={LAST_DISPLOMA}
              pathValue="value"
              value={LAST_DISPLOMA.find((option) => option?.value === formik.values.diplomaType) || null}
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              borderRadius={6}
              fullWidth
              label="Code diplôme"
              name="diplomaCode"
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              borderRadius={6}
              fullWidth
              label="Intitulé exacte du diplôme"
              name="diplomaLabel"
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              borderRadius={6}
              fullWidth
              label="Intitulé exacte de la formation"
              name="trainingLabel"
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid
          className={css({
            textAlign: 'center',
            marginTop: spacing(4),
          })}
          item
          xs
        >
          <Button
            className={css({ borderRadius: 20 })}
            color="primary"
            fullWidth
            onClick={() => prev(formik.values)}
            variant="outlined"
          >
            Retour
          </Button>
        </Grid>
        <Grid
          className={css({
            textAlign: 'center',
            marginTop: spacing(4),
          })}
          item
          xs
        >
          <Button
            className={css({ borderRadius: 20 })}
            color="primary"
            fullWidth
            onClick={formik.handleSubmit}
            type="submit"
            variant="contained"
          >
            Suivant
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

StepThree.propTypes = {
  data: PropTypes.object,
  next: PropTypes.func,
  prev: PropTypes.func,
};

const stepFourValidationSchema = Yup.object({
  registrationFees: Yup.string().required('Requis'),
  programCost: Yup.string().required('Requis'),
  workedLangage: Yup.array().required('Requis'),
  openingDate: Yup.string().required('Requis'),
  closingDate: Yup.string().required('Requis'),
  applicationStartDate: Yup.string().required('Requis'),
  applicationClosingDate: Yup.string()
    .notOneOf(
      [Yup.ref('applicationStartDate')],
      "La date de fin doit être ultérieure à la date d'ouverture des candidatures."
    )
    .required('Requis'),
});

const StepFour = ({ data, next, prev }) => {
  const {
    css,
    theme: { spacing },
  } = useStyles();

  const { data: languages = [], isLoading: langLoading } = useQuery(
    getLangFormation,
    {
      key: 'languagesFormation',
    }
  );

  const formik = useFormik({
    initialValues: data,
    validationSchema: stepFourValidationSchema,
    onSubmit: (values) => next(values),
  });

  const dateRef = new Date();

  useEffect(() => {
    dateRef.setDate(new Date(formik.values.applicationStartDate).getDate() + 1);
  }, [formik.values.applicationStartDate]);

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: spacing(3),
        '@media (max-width:768px)': { margin: spacing(1) }
      })}
    >
      <Grid container  >
        <Grid container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              borderRadius={6}
              fullWidth
              label="Frais d'inscription (€)"
              name="registrationFees"
              type="number"
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikTextField
              formik={formik}
              borderRadius={6}
              fullWidth
              label="Frais de scolarité (€)"
              name="programCost"
              type="number"
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikAutocompletePx
              formik={formik}
              borderRadius={6}
              fullWidth
              getOptionLabel={(option) => option.label}
              label="Langue d'enseignement"
              loading={langLoading}
              loadingText="En chargement"
              multiple
              name="workedLangage"
              options={languages}
              value={formik.values.workedLangage}
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikDatePicker
              formik={formik}
              borderRadius={6}
              fullWidth
              variant='outlined'
              label="Début de formation"
              name="openingDate"
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikDatePicker
              formik={formik}
              borderRadius={6}
              fullWidth
              variant='outlined'
              label="Fin de la formation"
              name="closingDate"
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikDatePicker
              formik={formik}
              borderRadius={6}
              fullWidth
              variant='outlined'
              label="Date d'ouverture des candidatures"
              name="applicationStartDate"
            />
          </Grid>
        </Grid>
        <Grid className={css({ marginTop: spacing(3) })} container>
          <Grid item xs={12}>
            <FormikDatePicker
              formik={formik}
              borderRadius={6}
              fullWidth
              variant='outlined'
              label="Date de fin des candidatures"
              minDate={dateRef.setDate(
                new Date(formik.values.applicationStartDate).getDate() + 1
              )}
              name="applicationClosingDate"
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid
          className={css({
            textAlign: 'center',
            marginTop: spacing(4),
          })}
          item
          xs
        >
          <Button
            className={css({ borderRadius: 20 })}
            color="primary"
            fullWidth
            onClick={() => prev(formik.values)}
            variant="outlined"
          >
            Retour
          </Button>
        </Grid>
        <Grid
          className={css({
            textAlign: 'center',
            marginTop: spacing(4),
          })}
          item
          xs
        >
          <Button
            className={css({ borderRadius: 20 })}
            color="primary"
            fullWidth
            onClick={formik.handleSubmit}
            type="submit"
            variant="contained"
          >
            Suivant
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

StepFour.propTypes = {
  data: PropTypes.object,
  next: PropTypes.func,
  prev: PropTypes.func,
};

const stepFiveValidationSchema = Yup.object({
  description: Yup.string().required('Requis'),
});

const StepFive = ({ data, isLoading, next, prev }) => {
  const {
    classes,
    css,
    theme: { spacing },
  } = useStyles(styles);

  const formik = useFormik({
    initialValues: data,
    enableReinitialize: true,
    validationSchema: stepFiveValidationSchema,
    onSubmit: (values) => {
      next(values, true);
    },
  });

  const [count, setCount] = React.useState(0);
  const [textarea, setTextarea] = React.useState(formik.values.description);

  const [countAspect, setCountAspect] = React.useState('countAspect');
  const countAspectRef = React.useRef();
  countAspectRef.current = countAspect;

  const handleSubmit = () => {
    if (!textarea) {
      formik.values.description = ' ';
    } else {
      formik.values.description = textarea;
    }
    formik.handleSubmit();
  };

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: spacing(3),
        '@media (max-width:768px)': { margin: spacing(1) }
      })}
    >
      <div className={css({ width: '100%' })}>
        <CKEditor
          className={css({
            width: '100%',
            resize: 'none',
          })}
          config={{
            wordCount: {
              onUpdate: (stats) => {
                setCount(stats.characters);
              },
            },
            toolbar: [
              'numberedList',
              'bulletedList',
            ],
          }}
          data={textarea}
          editor={Editor}
          onChange={(event, editor) => {
            setTextarea(editor.getData());
            if (count > 3000) {
              setCountAspect('countAspectPassed');
            } else {
              setCountAspect('countAspect');
            }
          }}
        />
        <div style={{ marginTop: spacing(2) }} className={classes[countAspectRef.current]}>{count} / 3000</div>
      </div>
      <Grid container spacing={2}>
        <Grid
          className={css({
            textAlign: 'center',
            marginTop: spacing(4),
          })}
          item
          xs
        >
          <Button
            className={css({ borderRadius: 20 })}
            color="primary"
            fullWidth
            onClick={() => prev(formik.values)}
            variant="outlined"
          >
            Retour
          </Button>
        </Grid>
        <Grid
          className={css({
            textAlign: 'center',
            marginTop: spacing(4),
          })}
          item
          xs
        >
          {countAspectRef.current === 'countAspect' ? (
            <Button
              className={css({ borderRadius: 20 })}
              color="primary"
              disabled={isLoading}
              fullWidth
              onClick={handleSubmit}
              type="submit"
              variant="contained"
            >
              Créer
            </Button>
          ) : (
            <Button
              className={css({ borderRadius: 20 })}
              color="primary"
              disabled
              fullWidth
              type="submit"
              variant="contained"
            >
              Créer
            </Button>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

const styles = () => ({
  countAspect: {
    color: 'black',
  },
  countAspectPassed: {
    color: 'red',
  },
  text: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    color: '#152652',
  },
});

StepFive.propTypes = {
  data: PropTypes.object,
  next: PropTypes.func,
  prev: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default CreateFormation;
